module.exports = __webpack_public_path__ + "assets/img/customers5.4cdcb67b.png";